(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/components/receiver/receiver-bottom-sheet.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/components/receiver/receiver-bottom-sheet.js');
"use strict";

const ReceiverDetails = svs.grassroots.components.receiver.receiver_details;
const BottomSheet = svs.ui.ReactBottomSheet.BottomSheet;
const ReceiverBottomSheet = _ref => {
  let isOpen = _ref.isOpen,
    close = _ref.close,
    receiver = _ref.receiver;
  return React.createElement(BottomSheet, {
    behavior: "modal",
    customer: svs.grassroots.tenant,
    isExpanded: true,
    isFixed: true,
    isVisible: isOpen,
    onStateChange: newState => {
      if (newState.state === 'closed') {
        close();
      }
    }
  }, React.createElement(ReceiverDetails, {
    receiver: receiver
  }));
};
svs.grassroots.components.receiver.ReceiverBottomSheet = ReceiverBottomSheet;

 })(window);